import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { popUpMessageChange, 
        editCards, 
        deleteCards, 
        editFeaturesGroup, 
        editFigures,
        toggleSwitch,
        selectedCardsGroupsChange } from '../../actions';

import { _ } from '../../functions/translator.js';

import { Button } from '@material-ui/core';

import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { Form } from 'react-bootstrap';

import SendIcon from '@material-ui/icons/Send';

import { postData } from '../../functions/postData.js';
import { reloadCardsGroupsFeatures } from '../../functions/map/reloadCardsGroups';
import { showMessage } from '../../functions/popUpMessage.js';
import { ToggleActions } from '../../constants/constants.js';

const RegisterSelect = (props) => {
    const [protocolIds, setProtocolIds] = useState([]);
    const [inputProtocolValue, setInputProtocolValue] = useState('');
    const [showProtocol, setShowProtocol] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [customCardFieldSelects, setCustomCardFieldSelects] = useState({});
    const [duplicateWarning, setDuplicateWarning] = useState(null);

    useEffect(() => {
        if (props.addNewRegister.value?.protocol_id) {
            setShowProtocol(true)
        }
    }, [props.addNewRegister]);

    const getProtocolName = (protocolId) => {
        for (const protocolgroupData of Object.values(props.projectData.protocolgroups)) {
            for (const protocolData of Object.values(protocolgroupData.protocols)) {
                if (protocolData.id === protocolId) {
                    return `${protocolgroupData.attributes.name} - ${protocolData.attributes.name}`;
                }
            }
        }
        return null;
    };

    const getDuplicateProtocolNames = () => {
        const selectedFiguregroupIds = new Set();
        for (const cardsGroupId of props.selectedCardsGroups) {
            const cardsGroupData = props.projectData.cards_groups[cardsGroupId];
            if (cardsGroupData?.attributes?.figuregroup_id) {
                selectedFiguregroupIds.add(cardsGroupData.attributes.figuregroup_id);
            }
        }

        const existingProtocolIds = new Set();
        for (const cardsGroupData of Object.values(props.projectData.cards_groups)) {
            if (selectedFiguregroupIds.has(cardsGroupData.attributes?.figuregroup_id)) {
                if (cardsGroupData.attributes.protocol_id) {
                    existingProtocolIds.add(cardsGroupData.attributes.protocol_id);
                }
            }
        }

        const duplicateNames = [];
        for (const selectedProtocolId of protocolIds) {
            if (existingProtocolIds.has(selectedProtocolId)) {
                const name = getProtocolName(selectedProtocolId);
                if (name) duplicateNames.push(name);
            }
        }
        return duplicateNames;
    };

    const submitNewRegister = async () => {
        const message = _("Generando Nuevos Registros") + '...';
        showMessage(props, message, { loading: true });
        const urlPost = {
            project_id: props.projectData.id,
            protocol_ids: protocolIds,
            cards_group_ids: props.selectedCardsGroups,
            customcard_id: props.addNewRegister.value.id,
            grouped: isChecked,
            customcardfields: customCardFieldSelects,
        };

        handleClose();
        const response = await postData('/web-api/create-related-cards-groups', urlPost);
        handleResponse(response);
    };

    const handleOnClick = async () => {
        const duplicates = getDuplicateProtocolNames();
        if (duplicates.length > 0) {
            setDuplicateWarning(duplicates);
            return;
        }
        await submitNewRegister();
    };

    const handleConfirmDuplicate = async () => {
        setDuplicateWarning(null);
        await submitNewRegister();
    };

    const handleCancelDuplicate = () => {
        setDuplicateWarning(null);
    };

    const handleClose = () => {
        props.toggleSwitch(ToggleActions.ADD_NEW_REGISTER, false);
        setProtocolIds([]);
        setInputProtocolValue('');
        setShowProtocol(false);
        setIsChecked(false);
        setDuplicateWarning(null);
        props.selectedCardsGroupsChange([]);
    };

    const handleResponse = async (response) => {
        if (response && response.status === 'success') {
            reloadCardsGroupsFeatures(props, response.new_cards_group_ids);
            showMessage(props, '¡' + _('Se han generado los protocolos correctamente') + '!');
        } else {
            showMessage(props, _('No se pudieron generar los protocolos') + '.');
        }
    };

    const handleCheckChange = () => {
        setIsChecked(!isChecked);
      };

    const handleProtocolChange = (event, value) => {
        const newProtocolIds = value.map(protocolInfo => protocolInfo.id);
        setProtocolIds(newProtocolIds);
    };

    const handleProtocolInputChange = (event, value, reason) => {
        if (reason === 'input') {
            setInputProtocolValue(value);
        }
    };

    const handleSelectOptionsChange = (event, value, type) => {
        setCustomCardFieldSelects({...customCardFieldSelects,[type]:value.attributes.name})
    };

    const handleStringInputChange = (event, value, type) => {
        setCustomCardFieldSelects({...customCardFieldSelects,[type]:value})
    };

    const filterOptions = (options, state) => {
        const filteredOptions = [];
        const searchInput = state.inputValue.trim().toLowerCase();
        const hasInputText = searchInput.length > 0;
        for (const option of options) {
            if (protocolIds.includes(option.id)) continue;
            const protocolName = option.name.toLowerCase();
            if (hasInputText && !protocolName.includes(searchInput)) continue;
            filteredOptions.push(option);
        }
        return filteredOptions;
    };

    const render = props.addNewRegister.show;
    if (!render) return <div></div>;
    const customCardFieldsData = Object.values(
        props.projectData.customcards[props.addNewRegister.value.id].customcardfields
    ).filter(
        c => ["select", "multiselect", "string"].includes(c.attributes.type_)
    )

    let stageProtocolIds = [];
    for (const stageData of Object.values(props.projectData.stages)) {
        if (props.stageIds.length > 0 && !props.stageIds.includes(stageData.id)) continue;
        stageProtocolIds = stageProtocolIds.concat(
            Object.keys(stageData.protocols).map(protocolId => parseInt(protocolId))
        );
    }

    const protocolOptions = [];
    for (const protocolgroupData of Object.values(props.projectData.protocolgroups)) {
        const protocolgroupName = protocolgroupData.attributes.name;
        for (const protocolData of Object.values(protocolgroupData.protocols)) {
            if (!stageProtocolIds.includes(protocolData.id)) continue;
            const protocolName = protocolData.attributes.name;
            const protocolFullName = `${protocolgroupName} - ${protocolName}`;
            protocolOptions.push({
                id: protocolData.id,
                name: protocolFullName
            });
        }
    }

    return (
        <div>
            <div className='sensitive-background' onClick={handleClose}></div>
            <div className="add-cards-groups-card-layout card-color">
                <h3 className='mt-4 mb-4'>{_("Crear Nuevo Registro")}</h3>
                {customCardFieldsData.map((customcardField) => {
                    let customcardFieldType = customcardField.attributes.type_
                    if (customcardFieldType === "string") {
                        return (
                            <div className='d-flex flex-column'>
                                <Form.Label className='mt-2'>{customcardField.attributes.name}:</Form.Label>
                                <TextField
                                    onChange={(event) => handleStringInputChange(event, event.target.value, customcardField.attributes.reference_field)}
                                    variant='outlined'
                                />
                            </div>
                        )
                    }
                    let selectOptions = customcardField.selectoptions
                    return <>
                            <Form.Label>{customcardField.attributes.name}:</Form.Label>
                            <Autocomplete
                            multiple={customcardFieldType === "multiselect" ? true : false}
                            options={Object.values(selectOptions)}
                            getOptionLabel={(option) => option.attributes.name}
                            onChange={(event, value) => handleSelectOptionsChange(event, value, customcardField.attributes.reference_field)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant='outlined'
                                    placeholder={_('Busca Aquí') + '...'}
                                />
                            )}
                            className='mb-2'
                            />
                            </>
                    }
                )}
                {showProtocol &&
                    <div>
                        <h4 className='mt-4 mb-4'>{_("Seleccione los Protocolos que desea agregar")}</h4>
                        <Form.Label>{_('Protocolos')}:</Form.Label>
                        <Autocomplete
                            multiple
                            options={protocolOptions}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.name}
                            onChange={handleProtocolChange}
                            inputValue={inputProtocolValue}
                            onInputChange={handleProtocolInputChange}
                            filterOptions={filterOptions}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant='outlined'
                                />
                            )}
                        />
                    </div>
                }
                <Form.Group className='mt-2' controlId="check">
                    <Form.Check
                    className='w-75'
                    type="checkbox" 
                    label={_('Agrupar')}
                    checked={isChecked}
                    onChange={handleCheckChange}
                    name="check"
                    />
                </Form.Group>
                <div className='d-flex justify-content-center'>
                    <Button variant="contained" onClick={handleOnClick} className='success-button mt-4'>
                        <SendIcon />
                        <span style={{ paddingLeft: 10 }}>{_('Generar')}</span>
                    </Button>
                </div>
            </div>
            {duplicateWarning && (
                <div>
                    <div className='duplicate-warning-overlay' onClick={handleCancelDuplicate}></div>
                    <div className='duplicate-warning-card card-color'>
                        <h4 className='mt-3 mb-3'>{_("Protocolos Duplicados")}</h4>
                        <p>{_("Los siguientes protocolos ya existen en los registros seleccionados")}:</p>
                        <ul className='duplicate-warning-list'>
                            {duplicateWarning.map((name, index) => (
                                <li key={index}>{name}</li>
                            ))}
                        </ul>
                        <p className='mt-3'><strong>{_("¿Desea duplicarlos?")}</strong></p>
                        <div className='d-flex justify-content-around mt-4 mb-3'>
                            <Button variant="contained" className='confirm-success-button' onClick={handleConfirmDuplicate}>
                                {_('Continuar')}
                            </Button>
                            <Button variant="contained" className='confirm-cancel-button' onClick={handleCancelDuplicate}>
                                {_('Cancelar')}
                            </Button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

function mapStateToProps(state) {
    return {
        projectData         : state.projectData,
        popup               : state.popup,
        popUpMenu           : state.popUpMenu,
        day                 : state.day,
        cardCategoryIds     : state.filters.cardCategoryIds,
        protocolsIds        : state.filters.protocolIds,
        status              : state.filters.status,
        customcardId        : state.filters.customcardId,
        userRole            : state.userRole,
        selectedCardsGroups : state.selectedCardsGroups,
        qualityProgress     : state.qualityProgress,
        zoneIds             : state.filters.zoneIds,
        editMode            : state.switches.editMode,
        activeTab           : state.activeTab,
        stageIds            : state.filters.stageIds,
        addNewRegister      : state.switches.addNewRegister,
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleSwitch,
        selectedCardsGroupsChange,
        popUpMessageChange,
        deleteCards,
        editCards,
        editFeaturesGroup,
        editFigures
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(RegisterSelect);
